import { Link } from "react-router-dom";
import { Phone } from "lucide-react";
import { useSite } from "@/context/SiteContext";
import { track } from "@/lib/api";
import Reveal from "@/components/Reveal";

export default function CTASection({
  heading = "Protecting Your Family Can Start With One Conversation",
  text = "Tell Michael what you want your life insurance to accomplish. He will help you review the available options and determine what may fit your needs and budget.",
}) {
  const site = useSite();
  return (
    <section className="bg-navy relative overflow-hidden" data-testid="closing-cta">
      <div className="absolute inset-0 opacity-[0.06]" aria-hidden="true"
        style={{ backgroundImage: "radial-gradient(circle at 20% 30%, #C5A059 0, transparent 40%), radial-gradient(circle at 85% 80%, #C5A059 0, transparent 35%)" }} />
      <div className="container-site relative py-20 md:py-28 text-center">
        <Reveal>
          <h2 className="!text-cream text-3xl sm:text-4xl lg:text-5xl tracking-tight max-w-3xl mx-auto">{heading}</h2>
        </Reveal>
        <Reveal delay={0.12}>
          <p className="mt-6 text-lg text-cream/85 leading-relaxed max-w-2xl mx-auto">{text}</p>
        </Reveal>
        <Reveal delay={0.22}>
          <div className="mt-10 flex flex-col sm:flex-row items-center justify-center gap-4">
            <Link to="/quote" className="btn-accent w-full sm:w-auto" data-testid="cta-quote-button"
              onClick={() => track("cta_click", { location: "closing", action: "get_quote" })}>
              Request My Quote
            </Link>
            <a href={`tel:${site.phone_href}`} className="btn-outline !border-gold !text-gold-light hover:!bg-gold hover:!text-navy w-full sm:w-auto"
              onClick={() => track("phone_click", { location: "closing" })} data-testid="cta-call-button">
              <Phone className="h-5 w-5" aria-hidden="true" /> Call {site.phone_display}
            </a>
          </div>
          <p className="mt-6 text-cream/70 text-base">
            No pressure. No obligation. Just straightforward help understanding your options.
          </p>
        </Reveal>
      </div>
    </section>
  );
}
